export const buttonStyles = {
  // Backgrounds
  b010: 'bg-gray-010',
  b020: 'bg-gray-020',
  b030: 'bg-main-050',
  b040: 'bg-gray-050',
  b060: 'bg-gray-060',
  main040: 'bg-main-040',
  main050: 'bg-main-050',
  main090: 'bg-main-090',

  // Text Colors
  t090: 'text-text-090',
  t050: 'text-text-050',
  t010: 'text-text-010',

  // border
  border030: 'border-030'
}

export const backgrounds = {
  bg010: buttonStyles.b010,
  bg020: buttonStyles.b020,
  bg030: buttonStyles.b030,
  bg040: buttonStyles.b040,
  bg060: buttonStyles.b060,
  main040: buttonStyles.main040,
  main050: buttonStyles.main050,
  main090: buttonStyles.main090
}

export const colors = {
  text090: buttonStyles.t090,
  text050: buttonStyles.t050,
  text010: buttonStyles.t010
}

export const borders = {
  border030: buttonStyles.border030
}
